import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { Column, Row, Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { useGoober } from "../../../Design/GooberContext";
import { mobileMediaQuery } from "../../../Design/mediaQuery";
import { useTopBlockStyles } from "../../../Design/useTopBlockStyles";
import { SectionContainer } from "../../../Utils/SectionContainer";
import { defaultStyles } from "./defaultStyles";

const columnMediaQuery = `
  display: block;
  width: 100% !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
`;

interface ImageGalleryBlock1Props extends ComponentPropsWithRef<"table"> {
  headerContent: ReactNode;
  imageNode1?: ReactNode;
  imageNode2?: ReactNode;
  imageNode3: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const ImageGalleryBlock1 = forwardRef<
  HTMLTableElement,
  ImageGalleryBlock1Props
>(
  (
    { headerContent, imageNode1, imageNode2, imageNode3, styles = {}, ...rest },
    ref,
  ) => {
    const { css } = useGoober();

    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles,
      },
    );

    return (
      <SectionContainer cssProperties={marginStyles}>
        <Section
          ref={ref}
          style={{
            ...paddingStyles,
            ...backgroundStyles,
          }}
          {...rest}
        >
          <Row>
            <Column>{headerContent}</Column>
          </Row>
          <Row>
            <Column
              style={{ width: `${100 / 3}%` }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery} margin-bottom: 16px;
                }
              `}
            >
              {imageNode1}
            </Column>
            <Column
              style={{
                width: `${100 / 3}%`,
              }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery} margin-bottom: 16px;
                }
              `}
            >
              {imageNode2}
            </Column>
            <Column
              style={{ width: `${100 / 3}%` }}
              className={css`
                ${mobileMediaQuery} {
                  ${columnMediaQuery}
                }
              `}
            >
              {imageNode3}
            </Column>
          </Row>
        </Section>
      </SectionContainer>
    );
  },
);

ImageGalleryBlock1.displayName = "ImageGalleryBlock1";
